module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"remember-disclaimer":"阅读并同意","document-title":"注册金姆ID"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
